<template>
  <div>
    <div class="modalContainer row6">
      <header class="modalHeader">
        <p>
          {{ title }}
        </p>
      </header>
      <div class="modalBody">
        <p class="alignC" v-html="contents"></p>
      </div>
      <div class="modalFooter">
        <button @click="$emit('close')">{{confirmText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props:[
    'title', 
    'contents',
    'confirmText'
  ]
}
</script>